import { cn } from "@/lib/utils";
import CheckIcon from "@heroicons/react/24/solid/CheckIcon";
import TrashIcon from "@heroicons/react/24/solid/TrashIcon";

interface Props {
  chips: any[];
  setSelectedChips: (data: any) => void;
  loading?: boolean;
}

export default function Chips(props: Props) {
  const { chips, setSelectedChips, loading } = props;

  return (
    <div className="flex flex-wrap gap-2">
      {chips?.map((data: any) => (
        <button
          role="button"
          aria-disabled={loading}
          disabled={loading}
          onClick={() => {
            const filteredChips = chips.filter(
              (item: any) => item.id !== data.id,
            );
            setSelectedChips(filteredChips);
          }}
          key={data.id}
          className={cn(
            "h-11 max-w-[160px] px-2 py-3 bg-teal-500 rounded-2xl border border-teal-500 justify-start items-center gap-2 inline-flex",
            loading ? "cursor-not-allowed" : "",
          )}
        >
          <CheckIcon className="text-white size-5" />

          <span className="text-white text-ellipsis max-w-32 overflow-hidden whitespace-nowrap text-sm font-bold font-['DM Sans']">
            {data.title}
          </span>

          <span className="w-5 h-5 p-1 bg-white rounded-[72px] justify-start items-center gap-1.5 inline-flex">
            <TrashIcon className="text-assistant size-5" />
          </span>
        </button>
      ))}
    </div>
  );
}
